import CompanyFinancialSettingsForm from '@/components/Companies/Settings/CompanyFinancialSettingsForm';
import { SaveButton } from '@/components/_common';
import {
  useCompanySettings,
  useCreateCompanySettings,
  useUpdateCompanySettings,
} from '@/core/domain/enterprise/Companies/Companies.hooks';
import { CompanySettingsFormValues } from '@/core/domain/enterprise/Companies/Companies.types';
import { PageProps } from '@/types/PageProps';
import { useForm } from 'antd/lib/form/Form';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { FormattedMessage, useIntl } from 'react-intl';
import { useRouteMatch } from 'react-router-dom';

export default function CompanyFinancialSettingsPage({ route }: PageProps) {
  const intl = useIntl();
  const [form] = useForm<CompanySettingsFormValues>();

  const { companyId } = useRouteMatch<{ companyId: string }>().params;
  const { data, isLoading } = useCompanySettings(+companyId);
  const createMutation = useCreateCompanySettings();
  const updateMutation = useUpdateCompanySettings();

  useEffect(() => {
    if (data) {
      form.setFieldsValue({ ...data });
    } else {
      form.setFieldValue('isInstallmentFree', false);
    }
  }, [data]);

  const handleSave = async () => {
    const values = await form.validateFields();
    if (!data) {
      createMutation.mutateAsync({
        companyId: Number(companyId),
        isInstallmentFree: values.isInstallmentFree,
        shouldUpdateDueDateBasedOnCreationDate:
          values.shouldUpdateDueDateBasedOnCreationDate,
      });
    } else {
      updateMutation.mutateAsync({
        id: data.id,
        companyId: Number(companyId),
        isInstallmentFree: values.isInstallmentFree,
        shouldUpdateDueDateBasedOnCreationDate:
          values.shouldUpdateDueDateBasedOnCreationDate,
      });
    }
  };

  return (
    <>
      <Helmet title={intl.formatMessage({ id: route.name })} />
      <div className="page">
        <CompanyFinancialSettingsForm
          form={form}
          loading={isLoading}
          extra={
            <SaveButton onClick={handleSave} block>
              <FormattedMessage id="commons.entity.save" />
            </SaveButton>
          }
        />
      </div>
    </>
  );
}
